import type { SingleAggregateIdentityInterface, SingleAggregateModelInterface } from '@nts/std/interfaces';
import { NumericPropertyViewModel } from "../base-type/numeric-property-view-model";
import { OCCRootViewModel } from "../occ-root-view-model";

export class SingleAggregateRootViewModel<
  TModel extends SingleAggregateModelInterface<TIdentity>,
  TIdentity extends SingleAggregateIdentityInterface
> extends OCCRootViewModel<
  TModel,
  TIdentity
> {
  #fixedIdentity: NumericPropertyViewModel<number>;

  public get fixedIdentity(): NumericPropertyViewModel<number> {
    return this.getNumericPropertyViewModel<number>({
      action: (value) => this.#fixedIdentity = value,
      value: this.#fixedIdentity,
      propertyName: 'fixedIdentity',
    });
  }
}
